/**
 * Checks if `val` is `null` or `undefined`.
 *
 * @returns {boolean} `true` if `val` is `undefined` or `null`, otherwise `false`.
 */
export const isNil = <T>(val: T | null | undefined): boolean =>
  val === null || val === undefined
